import React, { useEffect, useRef, useState } from "react";
import styles from "./TruncatedTooltip.module.css";

/*
 * TruncatedTooltip — lamba text sirf `limit` characters tak dikhata hai,
 * poora text tap (mobile) / hover (desktop) par chhote popup me.
 * Setup Summary ki Call Triage row ke liye banaya — rules ki list bahut
 * lambi ho jaati thi aur poora card bhar deti thi.
 */
export default function TruncatedTooltip({ text = "", limit = 15, className = "" }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const full = String(text || "");
  const isLong = full.length > limit;
  const short = isLong ? `${full.slice(0, limit).trimEnd()}…` : full;

  // Bahar tap karne par band.
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", onDown);
    return () => document.removeEventListener("pointerdown", onDown);
  }, [open]);

  if (!isLong) return <span className={className}>{full}</span>;

  return (
    <span
      ref={wrapRef}
      className={`${styles.wrap} ${className}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className={styles.trigger}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        aria-expanded={open}
        aria-label={full}
      >
        {short}
      </button>
      {open && (
        <span role="tooltip" className={styles.bubble}>
          {full}
        </span>
      )}
    </span>
  );
}
